// DS: PO56
import React from 'react';
import { BiLink } from '../../biLogger';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url/dist/src/constants';
import Button from '../../Button';
import { IconSize } from '../../Icons/IconWrap';
import InfoIcon from '../../Icons/Info';
import s from './CookiesBanner.scss';
export var CookiesBanner = function (_a) {
    var onAccept = _a.onAccept, onManageInfo = _a.onManageInfo;
    var t = useTranslation().t;
    var handleManageInfoClick = function (e) {
        onManageInfo();
        e.preventDefault();
        return false;
    };
    var handleAcceptClick = function (e) {
        onAccept();
    };
    return (React.createElement("div", { className: s['root'] },
        React.createElement(InfoIcon, { className: s['info-icon'], size: IconSize.MEDIUM, disableDefaultColors: true }),
        React.createElement("div", { className: s['details'] },
            React.createElement(Trans, null,
                "We use cookies and other tracking technologies to improve your browsing experience on our site, analyze site traffic, and for marketing and functional purposes.",
                React.createElement("br", null),
                "To learn more read our ",
                React.createElement("a", { href: URLS.PRIVACY }, "Privacy Policy"),
                ".")),
        React.createElement("div", { className: s['buttons'] },
            React.createElement(BiLink, { className: s['manage-info'], onClick: handleManageInfoClick, href: "#" }, t('popup.cookiesbanner.manage_info')),
            React.createElement(Button, { view: 'b1-1', height: 'small', minWidth: '120px', fullWidth: true, onClick: handleAcceptClick, className: s['accept'] }, t('popup.cookiesbanner.accept')))));
};
CookiesBanner.displayName = 'CookiesBanner';
export default CookiesBanner;
//# sourceMappingURL=CookiesBanner.js.map